// floatingMenuConfigs.js
// Button configurations for the floating menu

import CommentIcon from "@mui/icons-material/Comment";
import LinkIcon from "@mui/icons-material/Link";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import AccountTreeRounded from "@mui/icons-material/AccountTreeRounded";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import EditIcon from "@mui/icons-material/Edit";
import LinkOffIcon from "@mui/icons-material/LinkOff";

/**
 * Get button configurations for selection menu
 * @returns {Array} Button configuration objects
 */
export const getSelectionButtonConfigs = () => [
    {
        type: "comment",
        label: "Comment",
        title: "Add Comment",
        icon: CommentIcon
    },
    {
        type: "reference",
        label: "Reference",
        title: "Add Reference",
        icon: LinkIcon
    },
    {
        type: "linkEntity",
        label: "Link Entity",
        title: "Link to Wikidata Entity",
        icon: AccountTreeRounded
    },
    {
        type: "findExpert",
        label: "Find an Expert",
        title: "Find an expert for this topic",
        icon: PersonSearchIcon
    },
    {
        type: "moreExamples",
        label: "More Examples",
        title: "Find more examples from selection",
        icon: LightbulbOutlinedIcon
    },
];

/**
 * Button configurations for link context menu
 */
export const LINK_BUTTON_CONFIGS = [
    {
        type: "openLink",
        label: "Open link",
        title: "Open link in a new tab",
        icon: OpenInNewIcon
    },
    {
        type: "editLink",
        label: "Edit",
        title: "Edit link",
        icon: EditIcon
    },
    {
        type: "removeLink",
        label: "Remove",
        title: "Remove link",
        icon: LinkOffIcon
    },
];
